import { AggregatedFilterState } from '../page-inventory-analysis';

type FilterReducerAction =
  | { type: 'set-assessment-date'; assessmentDate: string }
  | { type: 'set-critical-items-enabled'; enabled: boolean }
  | { type: 'set-critical-items-threshold'; threshold: number };
export function filterReducer(
  prevState: AggregatedFilterState,
  payload: FilterReducerAction
): AggregatedFilterState {
  switch (payload.type) {
    case 'set-assessment-date':
      return {
        ...prevState,
        assessmentDate: payload.assessmentDate
      };
    case 'set-critical-items-enabled':
      return {
        ...prevState,
        inventoryFilterConfig: {
          ...prevState.inventoryFilterConfig,
          criticalItemConfig: {
            ...prevState.inventoryFilterConfig.criticalItemConfig,
            enabled: payload.enabled
          }
        }
      };
    case 'set-critical-items-threshold':
      return {
        ...prevState,
        inventoryFilterConfig: {
          ...prevState.inventoryFilterConfig,
          criticalItemConfig: {
            ...prevState.inventoryFilterConfig.criticalItemConfig,
            threshold: payload.threshold
          }
        }
      };
    default:
      throw new Error(
        `[filterReducer] Unmapped action type '${
          (payload as any).type
        }'. Please report this error to the ConcussionRx team`
      );
  }
}
